import parse from 'date-fns/parse';
import setHours from 'date-fns/setHours';
import setMinutes from 'date-fns/setMinutes';

export const createDateTime = (date: string, time: string): Date => {
  const timeParts = time.split(':');
  if (timeParts.length < 2) {
    throw new Error(`Could not create datetime: time-string invalid: [${time}]`);
  }
  const hour = parseInt(timeParts[0], 10);
  const minutes = parseInt(timeParts[1], 10);

  const dateObj = parse(date, 'yyyy-MM-dd', new Date());
  return setMinutes(setHours(dateObj, hour), minutes);
};
